import { Select } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';

import styles from '../BasicParameters.module.scss';
import type { BasicParametersStore } from '../BasicParameters.store';
import type { ParameterLine } from '../ParameterLine.store';

interface Props {
  line: ParameterLine;
  store: BasicParametersStore;
}

export const MnemonicSelect = observer(function MnemonicSelect({ line, store }: Props) {
  const { isBaseParamsLoading } = store;
  return (
    <Select
      allowClear
      onClear={() => {
        line.setMnemonic(null);
      }}
      loading={line.isLoading || isBaseParamsLoading}
      disabled={!line.log.value || line.isLoading || isBaseParamsLoading}
      key={`${line.parameterType}-mnemonic`}
      onSelect={(value, option) => {
        if (option.label) {
          line.setMnemonic({ value: value, label: String(option.label) });
        }
      }}
      filterOption={(inputValue, option) => {
        if (option && option.label && option.value) {
          const lowerInput = inputValue.toLowerCase();
          return (
            String(option.label).toLowerCase().includes(lowerInput) ||
            String(line.getMnemonicName(option.value)).toLowerCase().includes(lowerInput)
          );
        }
        return false;
      }}
      showSearch
      className={styles.selectSearch}
      dropdownMatchSelectWidth={false}
      value={line.mnemonic.value?.id}
      optionLabelProp="label"
      options={line.mnemonicsOptions}
      sortOptions
      optionRender={(option) => {
        return (
          <div className={styles.selectOption}>
            <span className={styles.selectName}>{line.getMnemonicName(Number(option.value))}</span>{' '}
            <span className={styles.selectMnemo}>{option.label}</span>
          </div>
        );
      }}
    />
  );
});
